import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderEntryService } from '../../../../services/order-entry.service';

@Component({
    selector: 'delete-sample-dialog',
    templateUrl: 'delete-sample.component.html',
})
export class DeleteSampleDialog {

    order;
    sample;
    deleted = false;
    error = false;
    hasProfile;
    profiles = new Array();
    profileTests = new Array();

    constructor(
        private orderEntryService: OrderEntryService,
        public dialogRef: MatDialogRef<DeleteSampleDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        this.order = data.order;
        this.sample = data.sample;
        this.error = false;
        this.deleted = false;
        this.hasProfile = false;
        let profile = "";
        this.sample.deletedTests = new Array();
        this.sample.tests.forEach(
            test => {
                if (!test.profileId) {
                    this.sample.deletedTests.push(test)
                } else {
                    this.hasProfile = true;
                    if (test.profileId != profile) {
                        this.sample.deletedTests.push({ id: test.profileId, description: test.profileDescription, type: 'P' })
                        this.profiles.push(test.profileId)
                        profile = test.profileId;
                    }
                }
            })

        if(this.hasProfile){
            this.profiles.forEach(
                profile => {
                    this.order.samples.forEach(
                        sample =>
                        sample.tests.forEach(
                            test => {
                                if (test.profileId == profile && sample.labelId != this.sample.labelId){
                                    this.profileTests.push({ test, labelId: sample.labelId} )
                                }
                            }
                        )
                    )
                }
            )
        }
        
    }

    deleteOrder() {
        this.order.deletedTests = this.sample.deletedTests;
        //this.order.addedTests = this.order.tests.filter( function(test){ return (this.indexOf(test.id)<0 && test.type=="P")}, this.sample.deletedTests.map(test=>test.id))
        this.order.addedTests = [];
        this.order.orderDate += ":00";
        this.order.ward = {
            wardId: this.order.wardId
        }
        this.orderEntryService.modifyOrder(this.order).subscribe(
            data => {

                if (this.order.samples.length > data.length) { // && data.length != 0)
                    this.deleted = true;
                    this.closeDialog(true);
                } else {
                    this.error = true;
                    this.closeDialog(false);
                }


            },
            error => {
                this.error = true;
                this.closeDialog(false);
            }
        );
    }

    closeDialog(reload) {
        setTimeout(() => { this.dialogRef.close(reload) }, 3000)
    }

}